export const requirementTitles = function (
  type: string,
  quantifier: number | undefined,
) {
  switch (type) {
    case 'company_accounts':
      return 'Upload latest company accounts';
    case 'bank_statement':
      return 'Link your business bank account to share statements';
    case 'vat_return': {
      const quarter = quantifier && quantifier / 3;
      if (quarter && quarter > 1) {
        return `Upload business VAT returns for the last ${quarter} quarters`;
      }
      return 'Upload business VAT returns for the last quarter';
    }
    case 'management_accounts':
      return 'Upload current management accounts';
    case 'business_plan':
      return 'Upload your business plan';
    case 'aged_debtor_report':
      return 'Upload your aged debtor report';
    default:
      break;
  }
};
